import { defineComponent } from "vue";
import type { PropType } from "vue";

import type { IWizardStep } from "@/types/ComponentLibrary/component-library";

export default defineComponent({
  name: "FormBuilder",
  props: {
    level: {
      type: Number,
      default: 1,
    },
    treeStructure: {
      // provide more specific type to `Object`
      type: Object as PropType<ITree>,
      required: true,
      default: {} as ITree,
    },
  },
  data() {
    return {
      locationHash: window.location.href,
      currentLanguate: "SK"
    };
  },
  watch: {
    locationHash: {
      handler(newValue, oldValue) {
        console.log("hahahahahhaha ");
      },
      deep: true,
    },
  },
  created() {
    console.log("Form builder - Created");
    window.FormEngine.formBuilder = this;
  },
  computed: {
    hasWizard() {
      return window.FormEngine.engineConfig.builder?.wizard;
    },
    formTitle() {
      return window.FormEngine.engineConfig.builder?.formTitle
        ? window.FormEngine.engineConfig.builder?.formTitle
        : window.FormEngine.structure.structureJSON.form_name;
    },
    wizardSteps() {
      return window.FormEngine.form.wizardSteps as Array<IWizardStep>;
    },
    formName() {
      return window.FormEngine.structure.formName;
    },
    hasOverlays() {
      return window.FormEngine.structure.overlays;
    },
    overlays(){
      return Object.fromEntries(window.FormEngine.structure.overlays.entries());
    }
  },
});
